import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router";
import { Table, Button, Input, Select } from 'antd';
import PaginationComp from  'components/common/PaginationComp';

class NoticeView extends Component {
  state = {
    inputText: ''
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.disNoticeList(pageIdx);
  };

  onSearch = () => {
    this.props.onChangValue('schText', this.state.inputText);
    this.props.disNoticeList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      noticeList,
      pageInfo,

      onChangValue,
      onViewMode, 
      disNoticeDetail,
      sessionLoginInfo
    } = this.props;
    const { inputText } = this.state;
    const columns = [
      { title: 'No',  dataIndex: 'RNUM', width: 60, align: 'center' },
      { title: '제목', dataIndex: 'bodTitle', width: 350, align: 'left' },
      { title: '팝업유무', dataIndex: 'bodPopYn', width: 60, align: 'center' },
      { title: '작성일', dataIndex: 'bodMakeDate', width: 70, align: 'center' },
      { title: '조회수', dataIndex: 'bodHit', width: 60, align: 'center' },
    ];
    return (
      <Fragment>
        <h2 className="h2_t">공지사항</h2>
        <div className="srch_box">
          <Select
            style={{ width: 200, marginBottom: 8 }}
            value={valCondition.selValue}
            onChange={(value)=>onChangValue('selValue', value)}
          >
            <Select.Option key={'A'}>제목</Select.Option>
            <Select.Option key={'B'}>제목+내용</Select.Option>
          </Select>

          <Input.Search 
            placeholder=""
            value={inputText}
            onChange={(e)=>this.setState({inputText: e.target.value})}
            onPressEnter={this.onPressEnter}
            onSearch={this.onSearch}
            style={{ width: 400 }}
          />
        </div>
        {(sessionLoginInfo !== null 
          && sessionLoginInfo.ceType !== undefined && sessionLoginInfo.ceType !== null
          && (sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_YUJIN
            || sessionLoginInfo.ceType === process.env.REACT_APP_TYPE_MASTER)) &&
          <div >
            <Button 
              className="buttonR"
              type="primary"
              onClick={()=>{
                onViewMode('add');
              }}
            >글쓰기</Button>
          </div>
        }

        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={noticeList}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                disNoticeDetail(record.bodId);
              },
            };
          }}
        />
        <PaginationComp 
          pageInfo={pageInfo}
          onChange={this.onPageChange}
        />
      </Fragment>
    );
  }

}

export default withRouter(NoticeView);
